export const MOMENT_DATE_FORMAT = "D MMM YYYY h:mm a";
